export default __webpack_public_path__ + "static/media/ra-img.c182dda1.png";